import React from "react";
import getVersionInfo from "../../utils/versionInfo";

const Version: React.FC = () => {
  const versionInfo = getVersionInfo();

  return (
    <div className="container p-3">
      <div className="card">
        <div className="card-header">
          <h3>Application Version Information</h3>
        </div>
        <div className="card-body">
          <div className="mb-3">
            <strong>Version:</strong> {versionInfo.version}
          </div>
          <div>
            <strong>Build Date:</strong> {versionInfo.buildDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Version;
